import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  MenuItem,
  Modal,
  Select,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useLocation, useParams } from 'react-router-dom';
import { editRomResult } from '../../services/EditReportServices';
import UserVideoView from '../UserVideoView/UserVideoView';
import Loader from '../Common/Loader/Loader';
import SuccessMessage from '../SuccessMessage/SuccessMessage';
import bulb from '../../assets/Icons/bulb.svg';
import HintMessage from '../Common/HintMessage/HintMessage';

const EditRomReport = ({ open, handleClose, handleOpen, modalData }) => {
  const [success, setSuccess] = useState(false);
  const { sessionId, userId } = useParams();
  const [successRes, setSuccessRes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [defaultValues, setDefaultValues] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const querySessionId = queryParams.get("session_id");
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors, isDirty, dirtyFields, isValid },
    setValue,
  } = useForm({
    mode: 'onSubmit',
    defaultValues,
  });
  const editing_reason = watch('editing_reason');

  useEffect(() => {
    const subscription = watch((value, { name, type }) =>
      console.log(value, name, type)
    );
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    setDefaultValues({
      adjustedValue: modalData.assessment_output.value,
      improvement_opportunity_level:
        modalData.interpretation_config.interpretation,
      editing_reason: modalData.editing_reason,
      editing_comment: modalData.editing_comment,
    });
  }, [modalData]);

  useEffect(() => {
    if (editing_reason && editing_reason !== 'Other') {
      console.log('editing_reason', editing_reason);
      setValue('editing_comment', '');
    }
  }, [editing_reason]);

  const onSubmit = (data) => {
    setLoading(true);
    console.log('data', data);
    const jsonData = JSON.stringify({
      encrypted_session_id: sessionId ? sessionId : querySessionId,
      value: data.adjustedValue,
      exercise_id: modalData.assessment_output.exercise_id,
      edited_interpretation: data.improvement_opportunity_level,
      editing_reason: data.editing_reason,
      editing_comment: data.editing_comment,
    });
    console.log('body', jsonData);
    editRomResult(jsonData).then((res) => {
      console.log('res', res.data);
      if (res.data.code === 2000) {
        console.log('success', res.data);
        setSuccess(true);
        setSuccessRes(res.data.data);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    console.log('successRes', successRes);
  }, [successRes]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          overflow: 'auto',
          width: '665px',
          // height: 'auto',
          // maxHeight: '80vh',
          borderRadius: '20px',
        }}
      >
        {!success && (
          <div>
            <div className='h-[60px] bg-[#EFF4FF] flex items-center justify-between pl-6 pr-6'>
              <div className='text-[#101828] text-sm leading-5 font-medium'>
                Exercise Preview
              </div>
              <div>
                <CloseIcon
                  sx={{
                    height: '14px',
                    width: '14px',
                    color: '#415280',
                    opacity: '0.8',
                    cursor: 'pointer',
                  }}
                  onClick={handleClose}
                />
              </div>
            </div>
            {!loading && (
              <>
                <div
                  className='pl-6 pr-6'
                  style={{
                    maxHeight: '80vh',
                    overflow: 'scroll',
                    height: 'auto',
                  }}
                >
                  <div className='flex justify-between mt-7'>
                    <div className='text-[#101828]  font-semibold text-base leading-6'>
                      {modalData.assessment_name.toUpperCase()}
                    </div>
                    <div className='flex items-center'>
                      <div className='text-[#101828]  font-medium text-xs leading-4'>
                        Improvement Opportunity Level
                      </div>
                      <div className='flex items-center ml-2 bg-[#F0F0F0] gap-[5px] py-1 px-2 rounded-[18px]'>
                        <div
                          className='w-[6px] h-[6px] rounded-[50%]'
                          style={{
                            backgroundColor:
                              modalData.interpretation_config.font_color_code,
                          }}
                        ></div>
                        <div className='font-medium text-xs leading-[18px]'>
                          {modalData.interpretation_config.interpretation}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='mb-[18px] mt-[14px]'>
                    <UserVideoView
                      exerciseId={modalData.assessment_output.exercise_id}
                      sessionId={sessionId ? sessionId : querySessionId }
                      userId={userId}
                    />
                  </div>
                  <div>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: '#fff',
                            }}
                          />
                        }
                        aria-controls='panel1a-content'
                        id='panel1a-header'
                        sx={{
                          backgroundColor: '#415280',
                          borderRadius: '5px',
                          color: '#fff',
                        }}
                      >
                        <div className='text-xs leading-[14px] font-medium'>
                          Legend
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        {modalData.legends.map((legend, index) => {
                          return (
                            <div className='flex items-center' key={index}>
                              <div
                                style={{
                                  backgroundColor: legend.color_code,
                                }}
                                className='w-4 h-3 rounded-sm flex-shrink-0 flex-grow-0 pl-6'
                              ></div>
                              <div className='text-[#3F3D56] text-[14px] leading-4 font-normal text-left pl-5'>
                                {legend.legend}
                              </div>
                            </div>
                          );
                        })}
                      </AccordionDetails>
                    </Accordion>
                  </div>
                  <div className='mt-2 mb-5'>
                    <table className='w-full'>
                      <thead>
                        <tr className='bg-[#415280] rounded-[5px] h-[30px]'>
                          <th className='w-[288px]'></th>
                          <th className='text-center text-[#fff] text-xs leading-4 font-medium'>
                            Measured
                          </th>
                          <th className='text-center text-[#fff] text-xs leading-4 font-medium'>
                            Adjusted
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className='bg-[#F0F0F0]'>
                          <td className='pl-6 text-xs font-medium leading-4'>
                            Angle
                          </td>
                          <td className='text-center text-xs font-semibold'>
                            {modalData.assessment_output.value}
                          </td>
                          <td className='text-center py-2'>
                            <input
                              defaultValue={modalData.assessment_output.value}
                              className='w-[50px] h-6 text-center text-xs bg-transparent font-semibold border border-solid border-[#605F5F] rounded-[2px]'
                              type='number'
                              {...register('adjustedValue', {
                                required: true,
                                min: 0,
                              })}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className='my-5'>
                    <div className='bg-[#415280] py-2 pl-6 text-[#FFFFFF] rounded-[5px] text-xs leading-[14px] font-medium'>
                      Improvement Opportunity Level
                    </div>
                    <div className='flex items-center mt-2'>
                      <div className='w-2/5 text-xs leading-4'>
                        Improvement Opportunity Level Adjusted
                      </div>
                      <Controller
                        name='improvement_opportunity_level'
                        control={control}
                        rules={{ required: true }}
                        defaultValue={
                          modalData.interpretation_config.interpretation
                        }
                        render={({ field }) => (
                          <Select
                            {...field}
                            className='w-3/5 h-9'
                            sx={{
                              fontSize: '12px',
                              lineHeight: '16px',
                            }}
                            value={field.value || ''}
                            renderValue={(value) => (
                              <div className='flex'>
                                {modalData.improvement_opportunity_list.map(
                                  (item) => {
                                    console.log('item', item);
                                    if (item.interpretation == value) {
                                      return (
                                        <div
                                          className='rounded-sm text-xs py-1 px-4 font-medium'
                                          style={{
                                            backgroundColor:
                                              item.background_color_code,
                                            color: item.font_color_code,
                                          }}
                                        >
                                          {value}
                                        </div>
                                      );
                                    }
                                  }
                                )}
                              </div>
                            )}
                          >
                            {modalData.improvement_opportunity_list.map(
                              (item, index) => {
                                return (
                                  <MenuItem
                                    sx={{
                                      fontSize: '12px',
                                      lineHeight: '16px',
                                    }}
                                    key={index}
                                    value={item.interpretation}
                                  >
                                    {item.interpretation}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                        )}
                      />
                    </div>
                    <div className='flex items-center mt-2'>
                      <div className='w-2/5 text-xs leading-4 font-medium'>
                        Reason for Change
                      </div>
                      <Controller
                        name='editing_reason'
                        control={control}
                        defaultValue={modalData.editing_reason}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            value={field.value || ''}
                            className='w-3/5 h-9'
                            sx={{
                              fontSize: '12px',
                              lineHeight: '16px',
                            }}
                          >
                            {modalData.interpretation_edit_reason_list.map(
                              (item, index) => {
                                return (
                                  <MenuItem
                                    sx={{
                                      fontSize: '12px',
                                      lineHeight: '16px',
                                    }}
                                    key={index}
                                    value={item.reason}
                                  >
                                    {item.reason}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                        )}
                      />
                    </div>
                    {isDirty && errors.editing_reason && (
                      <HintMessage
                        imgUrl={bulb}
                        msg='Please select Reason for listing any Change'
                      />
                    )}
                    {errors.editing_comment && editing_reason === 'Other' && (
                      <HintMessage
                        imgUrl={bulb}
                        msg='  Mentioning Reason for Change is Mandatory to move
                     ahead'
                      />
                    )}
                    {editing_reason === 'Other' && (
                      <div className='flex items-center mt-2'>
                        <div className='w-2/5 text-xs leading-4 font-medium'>
                          If Other
                        </div>
                        <Controller
                          name='editing_comment'
                          control={control}
                          defaultValue={modalData.editing_comment}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              className='w-3/5'
                              variant='outlined'
                              value={field.value || ''}
                              placeholder='Type Here...'
                              sx={{
                                '& .MuiInputBase-root': {
                                  height: 36,
                                },
                                '& .MuiOutlinedInput-root': {
                                  fontSize: '12px',
                                  lineHeight: '16px',
                                },
                              }}
                            />
                          )}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className='border border-solid border-[#E9E9E9]'>
                  <div className='flex items-center justify-end pl-6 pr-6 gap-2 mt-3 mb-4'>
                    <Button
                      onClick={handleClose}
                      sx={{
                        backgroundColor: '#DF0F00',
                        color: '#fff',
                        borderRadius: '5px',
                        '&:hover': {
                          backgroundColor: '#DF0F00',
                          color: '#fff',
                        },
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleSubmit(onSubmit)}
                      sx={{
                        backgroundColor: '#788CFC',
                        color: '#fff',
                        borderRadius: '5px',
                        '&:hover': {
                          backgroundColor: '#788CFC',
                          color: '#fff',
                        },
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </>
            )}
            {loading && <Loader />}
          </div>
        )}
        {success && <SuccessMessage data={successRes} close={handleClose} />}
      </Box>
    </Modal>
  );
};

export default EditRomReport;
